import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvitationDetailsService {
  // Señal para saber si estamos en la vista de detalles
  public isInDetailsView = signal(false);
  
  // Subject para emitir acciones desde el header
  public shareInvitation$ = new Subject<void>();
  public deleteInvitation$ = new Subject<void>();

  constructor() {}

  setInDetailsView(value: boolean): void {
    this.isInDetailsView.set(value);
  }

  emitShareAction(): void {
    this.shareInvitation$.next();
  }

  emitDeleteAction(): void {
    this.deleteInvitation$.next();
  }
}
